import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { GetSponsorshipExcelExport } from "../../../services/api/dashboard-api";
import { Accordion, Card, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import DropdownUpArrow from "../../../assets/icons/Icon-Dashboard-ChevronUp-32px-Blue.svg";
import DropdownArrow from "../../../assets/icons/Icon-Dashboard-ChevronDown-32px-Blue.svg";
import DropdownArrowDisabled from "../../../assets/icons/Icon - Chevron - Down.svg";
import MemberIcon from "../../../components/member-icon/member-icon";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import ArrowUp from "../../../assets/icons/ArrowUp.svg";
import ArrowHover from "../../../assets/icons/ArrowHover.svg";
import DashboardExport from "../../../assets/icons/Icon-Dashboard-Export-32px-Blue.svg";
import DashboardEdit from "../../../assets/icons/Icon-Dashboard-Edit-32px-Blue.svg";
import DashboardExpand from "../../../assets/icons/Icon-Dashboard-Expand-32px-Blue.svg";
import {
  renderTableHealthcare,
  getSetToggled,
  getCollapsedStatus,
  toggleAccordion,
  useSortableData
} from "../../new-dashboard/dashboard-util/dashboard-utils";
import "../dashboard-healthcare/dashboard-healthcare.scss";
import "./dashboard-sponsorships.scss"
import "../../tasks/scenes/tasks-comments/shared-modal-header.scss";
import ExpandCollapseButton from "../../../components/expand-collapse-button/expand-collapse-button";
import ProjectCounter from "../../../components/project-counter/projectCounter";
import { Link } from "react-router-dom";
import { newDashboardMap } from "../new-dashboard-mapper";

const DashboardSponsorshipDonations = (props) => {
  const [members, setMembers] = useState(props.items ? props.items : null);
  const [toggled, setToggled] = useState([]);
  const [accordionId] = useState("sponsorships-accordion");
  const [collapsed, setCollapsed] = useState(true);
  const [showSponsorships, setShowSponsorships] = useState(false);
  const [seletedMember, setSeletedMember] = useState(null);
  const formatter = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
      useGrouping: false
    }
  );

  useEffect(() => {
    if (props.items) setMembers(props.items);
  }, [props]);

  useEffect(() => {
    if (members) setToggled(getSetToggled(members));
  }, [members]);

  const showSponsorshipsModal = (m) => {
    setShowSponsorships(true);
    setSeletedMember(m);
  };

  const { items, requestSort, getArrowDirectionFor } = useSortableData(members);

  const renderButtons = (m, toggleBoolean, toggleSource, disabled) => {
    
    const handleAccordianClick = (e) => {
      if (m.ActiveSponsorshipsDonations.length > 0) {
        let updatedToggled = toggled?.map((t) => {
          if (t.UserId == m.UserId) {
            t.Toggled = toggleBoolean;
          }
          return t;
        });
        toggleAccordion(accordionId + "-" + m.UserId);
        setToggled(updatedToggled)
        setCollapsed(getCollapsedStatus(accordionId))
      }
    }

    const handleExpandClick = (e) => {
      if (disabled) return;
      showSponsorshipsModal(m)
    }

    return (
      <div className="healthcare-button-row">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Edit {m.SponsorshipTaskName}</Tooltip>}>
          {
            m.AllowSponsorshipEdit
              ?
              <div>
                <Link to={`/tasks/edit/std/${m.SponsorshipTaskId}`} target="_blank" rel='noopener noreferrer'>
                  <img disabled={!m.AllowSponsorshipEdit} alt="dropdown-arrow" src={DashboardEdit} />
                </Link>
              </div>
              :
              <img disabled alt="dashboard-edit" src={DashboardEdit} />
          }
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Expand {m.SponsorshipTaskName}</Tooltip>}>
            <img disabled={disabled} alt="dashboard-expand" src={DashboardExpand} onClick={handleExpandClick} />
        </OverlayTrigger>
        {disabled ?
          <img disabled alt="dropdown-arrow" src={DropdownArrow} />
          :
          <img className="dropdown-up-arrow" alt="dropdown-arrow" src={toggleSource} onClick={handleAccordianClick} />
        }
      </div>
    );
  };
  

  if (items !== null && items?.length > 0) {
    return (
      <div className="new-dashboard table-wrapper dashboardSponsorshipsContainer">
        <div className={newDashboardMap.SD.staffer.includes(props.currSubDepartment) ? `no-scroll-dashboard`:`scrollable-dashboard`}>
          <table>
            <thead className="sticky-header-dashboard">
              <tr className="DashboardTableHeader">
                <th className="DashboardTableTitle">
                  Sponsorship Tracker
                  <div className="DashboardTableHeaderButtons">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Export Data</Tooltip>}
                    >
                      <img src = {DashboardExport} onClick={GetSponsorshipExcelExport} alt="Export Sponsorships" />
                    </OverlayTrigger>
                    <ExpandCollapseButton accordionId={accordionId} collapsed={collapsed} setCollapsed={setCollapsed} toggled={toggled} setToggled={setToggled}/>
                  </div>
                  <p className="subDepartmentTitle">Sponsorships and Donations</p>
                </th>
              </tr>
            </thead>

            {/* Project and Deals table  */}
            <Accordion>
              <Card className="MemberTableBodyWrapper">
                <thead className="MemberTableColumnHeader">
                  <tr className="MemberTableColumnTitles">
                    <th className="col-md-2 textEllipsis containerSorted">
                      <div onClick={() => requestSort('Name')} className={'sortedCenter'}>
                        <div className="containerTextSorted">
                          <p className="textSorted"> NAME</p>
                        </div>
                        {
                          getArrowDirectionFor("Name", "descending") && (
                            <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                          )
                        }
                        {
                          getArrowDirectionFor("Name", "ascending") && (
                            <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                          )
                        }
                        {
                          getArrowDirectionFor("Name") && (
                            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                          )
                        }
                      </div>
                    </th>

                    <th className="col-md-2 textEllipsis containerSorted">
                      <div onClick={() => requestSort('TotalSponsorshipCost')} className={'sortedCenter'}>
                        <div className="containerTextSorted">
                          <p className="textSorted">TOTAL SPONSORSHIP COST</p>
                        </div>

                        {
                          getArrowDirectionFor("TotalSponsorshipCost", "descending") && (
                            <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                          )
                        }
                        {
                          getArrowDirectionFor("TotalSponsorshipCost", "ascending") && (
                            <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                          )
                        }
                        {
                          getArrowDirectionFor("TotalSponsorshipCost") && (
                            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                          )
                        }
                      </div>
                    </th>

                    <th className="col-md-2 textEllipsis containerSorted">
                      <div onClick={() => requestSort('AverageSponsorshipCostPerPerson')} className={'sortedCenter'}>
                        <div className="containerTextSorted">
                          <p className="textSorted">AVERAGE SPONSORSHIP PER PERSON</p>
                        </div>

                        {
                          getArrowDirectionFor("AverageSponsorshipCostPerPerson", "descending") && (
                            <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                          )
                        }
                        {
                          getArrowDirectionFor("AverageSponsorshipCostPerPerson", "ascending") && (
                            <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                          )
                        }
                        {
                          getArrowDirectionFor("AverageSponsorshipCostPerPerson") && (
                            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                          )
                        }
                      </div>
                    </th>

                    <th className="col-md-2 textEllipsis containerSorted">
                      <div onClick={() => requestSort('NextUpcomingEventText')} className={'sortedCenter'}>
                      <div className="containerTextSorted">
                        <p className="textSorted">NEXT UPCOMING EVENT</p>
                      </div>

                        {
                          getArrowDirectionFor("NextUpcomingEventText", "descending") && (
                            <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                          )
                        }
                        {
                          getArrowDirectionFor("NextUpcomingEventText", "ascending") && (
                            <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                          )
                        }
                        {
                          getArrowDirectionFor("NextUpcomingEventText") && (
                            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                          )
                        }
                      </div>
                    </th>

                    <th className="col-md-1 textEllipsis containerSorted">
                      <div onClick={() => requestSort('TotalApproved')} className={'sortedCenter'}>
                      <div className="containerTextSorted">
                        <p className="textSorted">TOTAL APPROVED</p>
                      </div>

                        {
                          getArrowDirectionFor("TotalApproved", "descending") && (
                            <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                          )
                        }
                        {
                          getArrowDirectionFor("TotalApproved", "ascending") && (
                            <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                          )
                        }
                        {
                          getArrowDirectionFor("TotalApproved") && (
                            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                          )
                        }
                      </div>
                    </th>

                    <th className="col-md-1 textEllipsis containerSorted">
                      <div onClick={() => requestSort('TotalRejected')} className={'sortedCenter'}>
                      <div className="containerTextSorted">
                        <p className="textSorted">TOTAL REJECTED</p>
                      </div>

                        {
                          getArrowDirectionFor("TotalRejected", "descending") && (
                            <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                          )
                        }
                        {
                          getArrowDirectionFor("TotalRejected", "ascending") && (
                            <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                          )
                        }
                        {
                          getArrowDirectionFor("TotalRejected") && (
                            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                          )
                        }
                      </div>
                    </th>

                    <th className="col-md-1 textEllipsis containerSorted">
                      <div onClick={() => requestSort('TotalAwaitingApprovals')} className={'sortedCenter'}>
                      <div className="containerTextSorted">
                        <p className="textSorted">TOTAL AWAITING APPROVALS</p>
                      </div>
                        {
                          getArrowDirectionFor("TotalAwaitingApprovals", "descending") && (
                            <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                          )
                        }
                        {
                          getArrowDirectionFor("TotalAwaitingApprovals", "ascending") && (
                            <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                          )
                        }
                        {
                          getArrowDirectionFor("TotalAwaitingApprovals") && (
                            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                          )
                        }
                      </div>
                    </th>
                    <th className="col-md-1"></th>
                  </tr>
                </thead>
              </Card>
              <table>
                <tbody className="healthcare-tablebody">
                  {items &&
                    items.map((m) => {
                      return (
                        <tr key={m?.UserId} className="healthcare-table-row">
                          <Card>
                            <div className="MemberTableBody PowerDealsRow row contentCenter">
                              <td className="col-md-2 mt-2 healthcare-username">
                                <MemberIcon
                                  className="ml-3"
                                  member={{ userNameFull: m.Name }}
                                  type="user"
                                />
                                <span className="Memberoverlaybutton mt-1 pl-1">
                                  {m.Name}
                                </span>
                              </td>
                              <td className="col-md-2 mt-2">
                                {m.TotalSponsorshipCost}
                              </td>
                              <td className="col-md-2 mt-2">
                                {formatter.format(m.AverageSponsorshipCostPerPerson)}
                              </td>
                              <td className="col-md-2 mt-2 healthcare-last-updated">
                                {m.NextUpcomingEventText}
                              </td>
                              <td className="col-md-1 mt-2 healthcare-last-updated center">
                                <ProjectCounter status="approved" value={m.TotalApproved}/>
                              </td>
                              <td className="col-md-1 mt-2 healthcare-last-updated center">
                                <ProjectCounter status="rejected" value={m.TotalRejected}/>
                              </td>
                              <td className="col-md-1 mt-2 healthcare-last-updated center">
                                <ProjectCounter status="awaiting" value={m.TotalAwaitingApprovals}/>
                              </td>

                              {m.ActiveSponsorshipsDonations.length > 0 ? (
                                <td className="col-md-1">

                                  {(!toggled?.filter(t => t.UserId == m.UserId)[0] ? false : toggled?.filter(t => t.UserId == m.UserId)[0].Toggled) ? (
                                    renderButtons(m, false, DropdownUpArrow, false)

                                  ) : (
                                    renderButtons(m, true, m.ActiveSponsorshipsDonations.length > 0 ? DropdownArrow : DropdownArrowDisabled, false)
                                  )}
                                </td>
                              ) : (
                                <td className="col-md-1">
                                   {renderButtons(m, null, null, true)}
                                </td>
                              )}
                            </div>

                            {/* Dropdown For Deals Tables */}
                            <Accordion.Collapse
                              eventKey={m.UserId}
                              scrollable={true}
                              className={accordionId}
                              id={accordionId + "-" + m.UserId}
                            >
                              <Card.Body
                                scrollable={true}
                                className="scrollable-dashboard scrollable-power-deals"
                              >
                                {renderTableHealthcare(m.ActiveSponsorshipsDonations, true, true, true)}
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </Accordion>
          </table>
          {/* Expand Deals Table */}
          {seletedMember && showSponsorships && (
            <Modal
              key={seletedMember?.UserId}
              show={showSponsorships}
              onHide={() => setShowSponsorships(false)}
              contentClassName="deal-and-vacation-date-healthcare-modal-styles"
              dialogClassName="deal-and-vacation-date-healthcare-modal"
              backdropClassName="healthcare-modal-backdrop"
              scrollable={true}
            >
              <div className="popup-week healthcare-deal">
                <Modal.Header
                  className="header-popup"
                  closeButton
                >
                  <div className="healthcare-deal-task-name">
                    Active Sponsorships and Donations

                    <div className="healthcare-deal-user-name">
                      {seletedMember.Name}
                    </div>
                  </div>
                </Modal.Header>
                <hr></hr>
                {seletedMember.AllowSponsorshipEdit && <div className="healthcare-edit-button-container">
                    <div >
                    <Link to={`/tasks/edit/std/${seletedMember.SponsorshipTaskId}`} target="_blank"  rel='noopener noreferrer'>
                      <div className="healthcare-edit">
                          <img
                        alt="dropdown-arrow"
                        src={DashboardEdit}
                          />
                          Edit Table
                      </div>
                      </Link>
                    </div>
                  </div>}
                <Modal.Body className="header-body">
                  {renderTableHealthcare(
                    seletedMember.ActiveSponsorshipsDonations
                  )}
                </Modal.Body>
              </div>
            </Modal>
        )}
        </div>        
      </div>
    );
  }
  return null;
}

DashboardSponsorshipDonations.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  currSubDepartment: PropTypes.string
};

export default DashboardSponsorshipDonations;